import AdminProfile from '../../views/Account/AdminProfile';

export default function route() {
  return [
    {
      private: true,
      path: accessRoute.PROFILE.path,
      name: accessRoute.PROFILE.name,
      key: accessRoute.PROFILE.key,
      belongsToSidebar: false,
      element: <AdminProfile />,
    },
  ];
}

export const accessRoute = {
  PROFILE: {
    path: '/admin/profile',
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
    key: 'admin-profile',
    for: 'admin',
    name: 'Profile',
  },
};

export const getChildrenRoutes = () => {
  return route();
};
